import { Channel, EmbedInterface, GroupInterface, MessageInterface, TranscriptPayload } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Messages/Messages.Controller.ts
export class MessagesAPI {
  static getMessage(orgId: number, uuid: string) {
    return APIService.Server.get<MessageInterface>(`/messages/org/${orgId}/message/${uuid}`);
  }
  static getAllMessages(orgId: number, userId: number) {
    return APIService.Server.get<MessageInterface[]>(`/messages/org/${orgId}/user/${userId}`);
  }
  static updateMessage(orgId: number, uuid: string, message: Partial<MessageInterface>) {
    return APIService.Server.put<boolean>(`/messages/org/${orgId}/message/${uuid}`, message);
  }

  static saveMessage(message: Partial<MessageInterface>) {
    return APIService.Server.post<MessageInterface>(`/messages/org/${message.orgId}`, message);
  }
  static getTranscriptText(orgId: number, userId: number, channel: Channel, numberOfMessages: number) {
    return APIService.Server.get<string>(`/messages/org/${orgId}/user/${userId}/transcript/channel/${channel}/message-count/${numberOfMessages}`);
  }
  static getPastMessages(orgId: number, userId: number, token: string, limit: number = 20) {
    return APIService.Server.get<MessageInterface[]>(`/messages/org/${orgId}/user/${userId}/token/${token}/limit/${limit}`);
  }
  static getMessagesForTranscript(userId: number) {
    return APIService.Server.get<TranscriptPayload>(`/messages/user/${userId}/transcript`);
  }
}
